export default __webpack_public_path__ + "static/media/ic_avatar_default.0fd4e76c.svg";